import {createSelector} from 'reselect';

import useCancellationPolicy from './cancellationPolicy';
import {getListingSummary} from './listingSummary';
import {getSuperlativeBadges} from './listing';
import {getFirstPayment, getPriceLabels, getTotals} from './priceDetails';
import {getSiteName} from './system';
import {
    isDatePickerModalOpen,
    isGuestSelectorModalOpen,
    isRequestToBookModalOpen,
    isInquiryModalOpen
} from './modalStates';
import {getBookingType, getTakesInquiries} from './listing';
import {getTravelerFeatures} from './store';

const getViewDetailsTotalData = createSelector(
    [getPriceLabels, getTotals],
    (labels, totals) => ({
        labels,
        showViewDetailsLink: !!(totals || /* istanbul ignore next */ {}).totalWithoutDeposits,
        totals
    })
);

const getRightRailData = createSelector(
    [
        useCancellationPolicy,
        getBookingType,
        getListingSummary,
        getViewDetailsTotalData,
        getSiteName,
        isDatePickerModalOpen,
        isGuestSelectorModalOpen,
        isRequestToBookModalOpen,
        isInquiryModalOpen,
        getTakesInquiries,
        getTravelerFeatures,
        getFirstPayment,
        getSuperlativeBadges
    ],
    (
        cancellationPolicy,
        bookingType,
        listingSummary,
        viewDetailsTotalData,
        siteName,
        datePickerPopoverOpen,
        guestSelectorPopoverOpen,
        requestToBookModalOpen,
        inquiryModalOpen,
        takesInquiries,
        travelerFeatures,
        firstPaymentData,
        superlativeBadges
    ) => {
        return {
            cancellationPolicy,
            listingSummaryData: listingSummary,
            viewDetailsTotalData,
            siteName,
            datePickerPopoverOpen,
            guestSelectorPopoverOpen,
            requestToBookModalOpen,
            inquiryModalOpen,
            showSecondaryAction: bookingType.onlineBookable && takesInquiries,
            displayBookingAssistance: travelerFeatures.displayBookingAssistance,
            firstPaymentData,
            superlativeBadges
        };
    }
);

export default getRightRailData;
export {getRightRailData, getViewDetailsTotalData};
